import apiClient from './api';

// Categorías personalizadas del usuario (endpoints/categories.py), además
// de las 7 categorías base fijas que ya trae la app. create() es
// idempotente en el backend: si ya existe una categoría con ese nombre,
// devuelve la existente en vez de duplicarla.
const categoryService = {
  getAll: async () => apiClient.get('/categories'),
  create: async (nombre) => apiClient.post('/categories', { nombre }),
  delete: async (id) => apiClient.delete(`/categories/${id}`),
};

export default categoryService;
